import { priceValues } from 'Common/filterValues';

const lowestPrice = priceValues[0].key;
const highestPrice = priceValues.slice(-1)[0].key;

/**
 * getMinRange
 * @param {number} from - from
 * @param {number} defaultVal - defaultVal
 * @return {array} - prices
 */
const getMinRange = (from, defaultVal) => {
  const minVal = priceValues.filter(i => i.key < from).slice(-1)[0];
  return minVal ? minVal.key : defaultVal;
};

/**
 * getMaxRange
 * @param {number} to - to
 * @param {number} defaultVal - defaultVal
 * @return {array} - prices
 */
const getMaxRange = (to, defaultVal) => {
  const maxVal = priceValues.filter(i => i.key > to)[0];
  return maxVal ? maxVal.key : defaultVal;
};

/**
 * getPriceFromValues
 * @param {number} priceFrom - priceFrom
 * @param {number} priceTo - priceTo
 * @param {number} selectedTo - selectedTo
 * @return {array} - prices
 */
export const getPriceFromValues = (priceFrom, priceTo, selectedTo) => {
  const minRange = getMinRange(priceFrom, lowestPrice);
  const maxRange = selectedTo || getMaxRange(priceTo, highestPrice);

  return priceValues.filter(i => i.key < maxRange && i.key >= minRange);
};

/**
 * getPriceToValues
 * @param {number} priceFrom - priceFrom
 * @param {number} priceTo - priceTo
 * @param {number} selectedFrom - selectedFrom
 * @return {array} - prices
 */
export const getPriceToValues = (priceFrom, priceTo, selectedFrom) => {
  const minRange = selectedFrom || getMinRange(priceFrom, lowestPrice);

  const maxRange = getMaxRange(priceTo, highestPrice);

  return priceValues.filter(i => i.key <= maxRange && i.key > minRange);
};



// WEBPACK FOOTER //
// ./src/Common/calculatePriceIncrements/index.js